import * as React from 'react'
require('../base.module.scss')
import * as st from './Spinner.module.scss'
import * as classnames from 'classnames'

const TRANSPARENT_1PX_GIF =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

export interface SpinnerProps {
    fillHeight?: boolean
}

export const Spinner: React.ComponentType<SpinnerProps> = ({ fillHeight }) => (
    <span className={classnames(st.spinner, { [st.fillHeight]: fillHeight })}>
        {fillHeight ? (
            <img className={st.spaceHolder} src={TRANSPARENT_1PX_GIF} />
        ) : null}
    </span>
)

// Add displayName to preserve the component name on snapshot testing
Spinner.displayName = 'Spinner'
